import { createAsyncThunk } from "@reduxjs/toolkit";
import { customFetch } from "../lib/network/Axios";
import config from "../config";
import { Campaign, CampaignFilter } from "../types/campaign.types";

const BASE_URL = config.apiBaseUrl;

export const getAllCampaigns = createAsyncThunk(
    "campaign/getAll",
    async (filter: CampaignFilter = {}) => {
        const isActive = filter.showDeactivated ? '0' : '1';
        const response = await customFetch.get(BASE_URL + `/campaigns?isActive=${isActive}`);
        return response.data as Campaign[];
    }
);

/** @deprecated Use getAllCampaigns thunk for Redux integration */
export const fetchAllCampaigns = async (isActive?: string) => {
	try {
		const response = customFetch.get(BASE_URL + `/campaigns?isActive=${isActive}`);
		return response;
	} catch (err) {
		console.log(err);
	}
};

export const fetchCampaignById = async (id?: string) => {
	try {
		const response = customFetch.get(BASE_URL + `/campaigns/${id}`);
		return response;
	} catch (err) {
		console.log(err);
	}
};

export const createCampaign = async (campaign: Campaign) => {
	try {
		const response = customFetch.post(BASE_URL + `/campaigns`, campaign);
		return response;
	} catch (err) {
		console.log(err);
	}
};

export const updateCampaign = async (id: string, campaign: Campaign) => {
    try {
        const response = customFetch.patch(BASE_URL + `/campaigns/${id}`, campaign);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const uploadCampainBanner = async (fileData: FormData) => {
    try {
        const response = customFetch.post(
            BASE_URL + `/campaigns/upload`,
            fileData,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        );
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const fetchCampaignPosts = async (id: string) => {
    try {
        const response = await customFetch.get(BASE_URL + `/campaigns/${id}/posts`);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const saveCampaignPost = async (
    body: any
) => {
    try {
        const response = await customFetch.post(
            BASE_URL + `/campaigns/post`,
            body,
            {
                headers: {
					'Content-Type': 'application/json'
                }
            }
        );
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const fetchDonationStatusByCampaignId = async (id?: string) => {
	try {
		const response = customFetch.get(BASE_URL + `/donations/by-campaign?campaignId=${id}`);
		return response;
	} catch (err) {
		console.log(err);
	}
};

export const fetchShipmentsByCampaignId = async (id?: string, view?: string) => {
    try {
        const response = customFetch.get(BASE_URL + `/campaigns/${id}/shipments${view ? `?view=${view}` : ''}`);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const fetchAllOrganizations = async () => {
    try {
        const response = await customFetch.get(BASE_URL + "/organizations");
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

